import AxiosClient from "../../../Network/AxiosClient";
import { env } from "../../../utilities/config";
import { buildGetApiUrl } from "../../../utilities/helpers";

const baseUrl = env.BASE_URL;

const KPI_SUMMARY_ENDPOINT = "/api/kpi/v1/summary";
const KPI_BREAKDOWN_ENDPOINT = "/api/kpi/v1/breakdown";
const YTD_PERFORMANCE_ENDPOINT = "/api/kpi/v1/ytd-performance";
const METRIC_CONFIGURATION_ENDPOINT = "/api/kpi/v1/weights";
const KPI_METRICS_ENDPOINT = "/api/kpi/v1/metrics";

export const KPIDashboardService = {
  kpiSummaryFetcher: async ({ userId }) => {
    const params = {};
    if (userId) params.user_id = userId;
    const url = buildGetApiUrl(KPI_SUMMARY_ENDPOINT, params);
    const response = await AxiosClient.get(url);
    return response.data;
  },

  kpiBreakdownFetcher: async ({
    page,
    metric,
    hierarchy,
    sort,
    query,
    geoFilters,
  }) => {
    const url = new URL(KPI_BREAKDOWN_ENDPOINT, baseUrl);
    const params = new URLSearchParams();

    params.append("page_no", page || 0);

    if (metric) {
      params.append("metric", metric);
    }
    if (hierarchy) {
      if (Array.isArray(hierarchy)) {
        hierarchy.forEach((item) => params.append("hierarchy", item));
      } else {
        params.append("hierarchy", hierarchy);
      }
    }
    if (sort?.sortBy) {
      params.append("sort_by", sort.sortBy);
    }
    if (sort?.sortOrder) {
      params.append("sorting_order", sort.sortOrder);
    }
    if (query) {
      params.append("query", query);
    }
    if (geoFilters?.circle?.length) {
      geoFilters.circle.forEach((circle) => params.append("circle", circle));
    }
    if (geoFilters?.zone?.length) {
      geoFilters.zone.forEach((zone) => params.append("zone", zone));
    }
    if (geoFilters?.area?.length) {
      geoFilters.area.forEach((area) => params.append("area", area));
    }
    if (geoFilters?.territory?.length) {
      geoFilters.territory.forEach((territory) =>
        params.append("territory", territory)
      );
    }
    if (geoFilters?.agency?.length) {
      geoFilters.agency.forEach((agency) => params.append("agency", agency));
    }
    url.search = params.toString();

    const response = await AxiosClient.get(url.toString());
    return response.data;
  },

  ytdPerformanceFetcher: async ({ userId, metric }) => {
    const params = {};
    if (userId) params.user_id = userId;
    if (metric) params.metric = metric;
    const url = buildGetApiUrl(YTD_PERFORMANCE_ENDPOINT, params);
    const response = await AxiosClient.get(url);
    return response.data;
  },

  metricConfigurationFetcher: async ({ role }) => {
    const url = buildGetApiUrl(METRIC_CONFIGURATION_ENDPOINT, { role });
    const response = await AxiosClient.get(url);
    return response.data;
  },

  metricListFetcher: async () => {
    const url = buildGetApiUrl(KPI_METRICS_ENDPOINT);
    const response = await AxiosClient.get(url);
    return response.data;
  },

  saveConfiguration: async ({ role, configuration }) => {
    const url = new URL(METRIC_CONFIGURATION_ENDPOINT, baseUrl);
    const response = await AxiosClient.post(url.toString(), {
      role: role,
      rows: configuration,
    });
    return response.data;
  },
};
